import { render, staticRenderFns } from "./InvoiceCustomer.vue?vue&type=template&id=49c13f22&"
import script from "./InvoiceCustomer.vue?vue&type=script&lang=js&"
export * from "./InvoiceCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports